import { render, staticRenderFns } from "./envoi-facture.vue?vue&type=template&id=2b65a1a9&scoped=true"
import script from "./envoi-facture.vue?vue&type=script&lang=ts"
export * from "./envoi-facture.vue?vue&type=script&lang=ts"
import style0 from "./envoi-facture.vue?vue&type=style&index=0&id=2b65a1a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65a1a9",
  null
  
)

export default component.exports